export default "__VITE_ASSET__DKwOvHuu__"